import { Component, OnInit } from '@angular/core';
import { ScriptLoaderService } from '../common/services/script-loader.service';

@Component({
  selector: 'app-glossary',
  templateUrl: './glossary.component.html',
  styleUrls: ['./glossary.component.css']
})
export class GlossaryComponent implements OnInit {
  constructor(private scriptLoaderService: ScriptLoaderService) {}

  ngOnInit() {
    this.scriptLoaderService
      .load('glossary')
      .then(data => {
        console.log('script loaded', data);
      })
      .catch(error => console.log(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/glossary/glossary.component.ts